import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TENANT } from './config';

// Tenant marker for theme + tenant-specific CSS overrides
document.documentElement.dataset.tenant = String(TENANT.id);

// Tenant-aware document title.
//
// index.html already renders a correct <title> and og:title from
// REACT_APP_SITE_TITLE, and that is what link previews, browser tabs and
// search engines read. Prefer it here rather than overwriting it — the old
// unconditional fallback appended "Investor Portal" to every tenant that was
// not REDEX, which labelled eMerge, a healthcare platform, as an investor
// product wherever its URL was shared.
//
// The remaining branch only covers builds that do not set the variable (the
// dev server, for instance). Capital-markets tenants keep their wording.
const isInvestorTenant = TENANT.id !== 'redex' && TENANT.id !== 'emerge';
document.title =
  process.env.REACT_APP_SITE_TITLE ||
  `${TENANT.branding.name} ${isInvestorTenant ? 'Investor Portal' : 'Portal'}`;

// Create root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();
